module.exports = require("slick-carousel/slick/slick-theme.css");